export default {
      id: "i-triangle-usage",
      viewBox: "4.95 0 4.924 9.9",
      url: __webpack_public_path__ + "img/sprite.svg#i-triangle",
      toString: function () {
        return this.url;
      }
    }